import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { EventsMap } from '@noths/polaris-client-next-redux';

import {
  getDeliveryByEventLabel,
  selectDeliveryByEventCost,
} from 'src/components/molecules/DeliveryEvent';
import { ReduxApplicationState } from 'src/redux/combinedReducer';
import {
  actions,
  selectDecoratedDeliveryOptions,
  selectMinMaxDeliveryEstimates,
} from 'src/redux/deliveryZoneOptions';
import { selectProductDeliveryByEvent } from 'src/redux/selectors';
import { DeliveryAreaLocationSelection } from './events';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [actions.setSelectedCountry.type]: (state, nextState, action) => {
    const { payload } = action as ReturnType<typeof actions.setSelectedCountry>;

    if (typeof payload === 'object') {
      const { selectedCountry, previouslySelectedZone } = state.deliveryZoneOptions;
      const fromLocation = `${selectedCountry} - ${previouslySelectedZone}`;
      const toLocation = `${payload.selectedCountry} - ${payload.selectedZone}`;
      const deliveryByEventCheapestPrice = selectDeliveryByEventCost(nextState);
      const productDeliveryByEvent = selectProductDeliveryByEvent(nextState);

      const deliveryEventIsAvailableForZone = Boolean(deliveryByEventCheapestPrice !== 'not set');
      const deliveryByEvent =
        deliveryEventIsAvailableForZone && productDeliveryByEvent?.arriveByEvent
          ? getDeliveryByEventLabel(productDeliveryByEvent.eventName).replace(' for', '')
          : 'not set';

      const countryDeliveryOptionCodes = selectDecoratedDeliveryOptions(nextState)
        .map((opt) => opt.optionCode)
        .join(', ');

      const { min: deliveryOptionMin, max: deliveryOptionMax } =
        selectMinMaxDeliveryEstimates(nextState);

      sendGAEvent<DeliveryAreaLocationSelection>({
        event: 'custom_event',
        event_action: 'Change delivery location',
        event_category:
          payload.sectionParent === 'delivery-area' ? 'Delivery & Returns' : 'Delivery summary',
        event_label: `FROM: ${fromLocation} TO: ${toLocation}`,
        delivery: {
          options: countryDeliveryOptionCodes,
          min_delivery_time: deliveryOptionMin,
          max_delivery_time: deliveryOptionMax,
          delivery_by_event: deliveryByEvent,
          delivery_by_event_cost: String(deliveryByEventCheapestPrice),
        },
      });
    }
  },
};
